// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"462":"efe0dc27","865":"8d02d1d4"}[chunkId] + ".css";
};